/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
export type GCStaffStacksListQueryVariables = {|
  slateID: string
|};
export type GCStaffStacksListQueryResponse = {|
  +gcStaffStacks: ?$ReadOnlyArray<?{|
    +stackRuleId: ?string,
    +owner: ?string,
    +name: ?string,
    +playersDisplayName: ?string,
    +numLineups: ?number,
  |}>
|};
export type GCStaffStacksListQuery = {|
  variables: GCStaffStacksListQueryVariables,
  response: GCStaffStacksListQueryResponse,
|};
*/


/*
query GCStaffStacksListQuery(
  $slateID: ID!
) {
  gcStaffStacks(slateId: $slateID) {
    stackRuleId
    owner
    name
    playersDisplayName
    numLineups
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "slateID"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "slateId",
        "variableName": "slateID"
      }
    ],
    "concreteType": "GreenMachineGCStaffStackType",
    "kind": "LinkedField",
    "name": "gcStaffStacks",
    "plural": true,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "stackRuleId",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "owner",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "name",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "playersDisplayName",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "numLineups",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "GCStaffStacksListQuery",
    "selections": (v1/*: any*/),
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "GCStaffStacksListQuery",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "70dc5d769c5ff616d75ea722a1c8a3c8",
    "id": null,
    "metadata": {},
    "name": "GCStaffStacksListQuery",
    "operationKind": "query",
    "text": "query GCStaffStacksListQuery(\n  $slateID: ID!\n) {\n  gcStaffStacks(slateId: $slateID) {\n    stackRuleId\n    owner\n    name\n    playersDisplayName\n    numLineups\n  }\n}\n"
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = 'bb6916acbb24886ea7bfde63f1ad2a9c';

module.exports = node;
